module.exports = __webpack_public_path__ + "img/cliff-explosives.80f4bb6f.png";